module.exports = __webpack_public_path__ + "img/tongguo.c9331460.png";